import script from "./DoTheMathQuiz.vue?vue&type=script&setup=true&lang=js"
export * from "./DoTheMathQuiz.vue?vue&type=script&setup=true&lang=js"

import "./DoTheMathQuiz.vue?vue&type=style&index=0&id=6b53499c&lang=scss"

const __exports__ = script;

export default __exports__